import { numberFormatter, constants, getStorage } from 'helpers'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import {
    TransactionKind,
    TransactionPayloadType,
    TransactionSource
} from 'storeTypes'
import { PaymentSourceIcons } from './PaymentSourceIcons'
import { getTransactionTypeSettings } from './helpers/getTransactionTypeSettings'
import { getAmountColor } from './helpers/getAmountColor'

export const PaymentItem: FC<{
    transaction: TransactionPayloadType
}> = ({ transaction }) => {
    const { t } = useTranslation()
    const clientDetails = getStorage(constants.CLIENT_DETAIL_LOCAL_STORE)

    const {
        type,
        amount,
        voucher_code: voucherCode,
        source,
        memo,
        matchingClientCode
    } = transaction

    const amountColor = getAmountColor({
        type: type || TransactionKind.VOUCHER_PAYMENT,
        amount: amount || 0,
        allEnrollment: clientDetails?.all_enrollment || 0
    })

    const memoByTransactionType: Partial<Record<TransactionKind, string>> = {
        [TransactionKind.DELIVERY]: t('clientDetails.delivery'),
        [TransactionKind.AWARD]: `${t('clientDetails.award')} ${memo ?? ''}`,
        [TransactionKind.AWARD_REVERSAL]: `${t('clientDetails.award')}${
            memo
                ? ` ${memo.replace(/ ([0-9]{4}-[0-9]{2}-[0-9]{2})/, '-$1')}`
                : '-R'
        }`
    }
    return (
        <div className="list--item">
            {type && (
                <div
                    aria-label={
                        getTransactionTypeSettings(type, amountColor).labelText
                    }
                >
                    {getTransactionTypeSettings(type, amountColor).icon}
                </div>
            )}
            <div>
                <p
                    className={`list--item--header payment--${amountColor}`}
                    data-testid="amount"
                >
                    {numberFormatter(
                        amount,
                        'CFA',
                        type === TransactionKind.PENDING
                    )}
                </p>
                <p className="list--item--sub-header">
                    {memoByTransactionType[type as TransactionKind] ||
                        `${
                            matchingClientCode
                                ? voucherCode?.split('-R')[0]
                                : voucherCode
                        }${matchingClientCode ? `-${matchingClientCode}` : ''}`}
                </p>
            </div>
            <PaymentSourceIcons
                type={
                    (type?.toUpperCase() as TransactionKind) ||
                    TransactionKind.VOUCHER_PAYMENT
                }
                source={
                    (source?.toUpperCase() as TransactionSource) ||
                    TransactionSource.ORANGE_MONEY
                }
            />
        </div>
    )
}
